<template>
  <v-app id="app">
    <router-view />
    <cookie-law theme="royal"
                :button-text="$t('cookieLawButton')">
      <div slot="message"
           class="standard-font-family">
        {{ $t('cookiesLawMessage') }}
      </div>
    </cookie-law>
  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import oLocalStorage from '@/services/objectLocalStorage';

export default {
  name: 'App',
  components: { CookieLaw },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateI18nLocale);
    this.updateI18nLocale();
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateI18nLocale);
  },
  methods: {
    updateI18nLocale() {
      let locale = oLocalStorage.get(keys.langSelected);
      if (locale !== null) {
        this.$i18n.locale = locale.langIso;
      }
    }
  }
};
</script>

<style lang="scss">
@import 'assets/css/home.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue